<template lang="pug">
.page-home-slideshow
  vue-flux.white.elevation-1.relative(
    :options="vfOptions",
    :images="vfImages",
    :transitions="vfTransitions",
    :captions="vfCaptions",
    ref="slider"
  )
    template(#controls)
      .d-flex.justify-space-between.mx-4
        v-btn(@click="() => $refs.slider.show('prev')", color="white", icon)
          v-icon(size="26") fas fa-chevron-left
        v-btn(@click="() => $refs.slider.show('next')", color="white", icon)
          v-icon(size="26") fas fa-chevron-right
    template(#caption)
      flux-caption(v-slot="captionProps")
        a.flux-caption(
          v-if="captionProps.caption.url",
          target="_blank",
          :href="captionProps.caption.url"
        )
</template>

<script>
import { VueFlux, FluxCaption } from "vue-flux";

export default {
  data: () => ({
    vfTransitions: ["zip"],
    simulationStatus: null,
    simulationResult: { price: "15000.00" },
  }),
  computed: {
    vfImages() {
      return this.$rest("slides")
        .list.map(({ mobile, desktop }) => (this.xsOnly ? mobile : desktop))
        .filter((path) => !!path)
        .map((path) => this.files + path);
    },
    vfOptions() {
      return {
        autoplay: true,
        aspectRatio: this.sm ? "1:1" : "1440:510",
      };
    },
    vfCaptions() {
      return this.$rest("slides").list.map(({ link }) => ({ url: link }));
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  beforeCreate() {
    this.$rest("slides").get();
  },
  components: {
    VueFlux,
    FluxCaption,
  },
};
</script>

<style>
.page-home-slideshow div.flux-caption {
  height: 100%;
  width: 100%;
  position: absolute;
  opacity: 0 !important;
}

.page-home-slideshow a.flux-caption {
  height: 100%;
  width: 100%;
  display: block;
}
</style>
